import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tagToText',
  standalone: true,
})
export class TagToTextPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace('<br />', ' ').replace(/(<([^>]+)>)/gi, '');
  }
}
